import { createDispatchHook, createSelectorHook, createStoreHook, } from "react-redux";
import { createContext } from "react";
import { buildCreateApi, coreModule, reactHooksModule, } from "@reduxjs/toolkit/query/react";
export const storeContext = createContext(null // This is just to satisfy TS, can never be null during runtime
);
export const useDispatch = createDispatchHook(storeContext);
export const useSelector = createSelectorHook(storeContext);
const useStore = createStoreHook(storeContext);
// Not sure why type casting is needed
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
export const createApi = buildCreateApi(coreModule(), reactHooksModule({ useDispatch, useSelector, useStore }));
